import React from "react";

interface ClockAreaFooterProps {
  text: string;
  icon?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const ClockAreaFooter: React.FC<ClockAreaFooterProps> = ({ text, icon, onClick }) => (
  <div
    className="bg-cc-bg-secondary w-full h-[28px] px-[18px] text-[10px] flex items-center cursor-pointer active:opacity-75 transition duration-200"
    onClick={onClick}
  >
    <span className="opacity-50">{text}</span>
    <div className="flex-1"></div>
    {icon && (
      <span className="clock-area-footer-icon text-[11px] w-[18px] h-[18px] leading-none flex items-center justify-center rounded-[4px] bg-[var(--cm-comp-bg-color)]">
        {icon}
      </span>
    )}
  </div>
);

export default ClockAreaFooter;
